module.exports = __webpack_public_path__ + "img/電気回路_5_8.93a7038a.png";